/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import AggressivePositivityService from 'cio/services/aggressive-positivity';
import Sprite from 'ember-animated/-private/sprite';
// @ts-ignore
import { fadeIn, fadeOut } from 'ember-animated/motions/opacity';
import fade from 'ember-animated/transitions/fade';
import { action, computed } from '@ember/object';
import FeaturesService from 'ember-feature-flags/services/features';
import AnalyticsService from 'cio/services/analytics';
import CampaignModel from 'cio/models/campaign';
import AuthService from 'cio/services/auth';
import AlertsService from 'cio/services/alerts';

interface AggressivePositivityModeToggleArgs {
  campaign: CampaignModel;
}

export default class AggressivePositivityModeToggle extends Component<AggressivePositivityModeToggleArgs> {
  @service analytics!: AnalyticsService;
  @service aggressivePositivity!: AggressivePositivityService;
  @service features!: FeaturesService;
  @service auth!: AuthService;
  @service alerts!: AlertsService;

  amiJonesImage = new URL('cio/assets/images/ami-jones.png', import.meta.url).toString();

  @computed('auth.user.userFlags.aggressive_positivity_mode_on')
  get isAggressivePositivityModeEnabled() {
    return this.auth.user?.userFlags.aggressive_positivity_mode_on ?? false;
  }

  fade = fade;
  // eslint-disable-next-line require-yield
  *fadeTransition({ insertedSprites, removedSprites }: { insertedSprites: Sprite[]; removedSprites: Sprite[] }) {
    insertedSprites.forEach((sprite) => {
      fadeIn(sprite);
    });

    removedSprites.forEach((sprite) => {
      fadeOut(sprite);
    });
  }

  @action
  toggle() {
    if (this.auth.user == null) {
      this.alerts.error(
        'aggressive-positivity.toggle.user-missing',
        'Unable to find current user. Refresh the page and try again.',
      );
      return;
    }

    if (this.isAggressivePositivityModeEnabled) {
      this.auth.user.updateUserFlag('aggressive_positivity_mode_on', false);
    } else {
      this.auth.user.updateUserFlag('aggressive_positivity_mode_on', true);
      this.aggressivePositivity.loadAll();
    }

    this.analytics.track('campaign', 'for_fun_positivity_mode_changed', {
      model: this.args.campaign,
      enabled: this.isAggressivePositivityModeEnabled,
    });
  }

  // Prevent double-calling the toggle action when the click happens on
  // FlySwitch and subsequently bubbles up to the on click handler on the
  // container
  @action
  onToggleClick(event: MouseEvent) {
    event.stopPropagation();
  }

  @action
  onChange() {
    this.toggle();
  }
}
